import { render } from "./MainMenu.vue?vue&type=template&id=9a4c1a9e&scoped=true&bindings={\"gameCodeInput\":\"data\",\"credentials\":\"data\",\"createNewGame\":\"options\",\"joinExistingGame\":\"options\"}"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"

import "./MainMenu.vue?vue&type=style&index=0&id=9a4c1a9e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9a4c1a9e"

export default script